/**
 * menu operations
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


import {
    loadMenuAction,
} from "../redux/menu/actions";
import {showError} from "./message";
import {fetchObjectList, excludeDeleted} from "./objects";
import {parseBSON} from "../utils";


export function loadMenu() {

    return async (dispatch, getState) => {

        const query = excludeDeleted({"type": {"$in": ["menu", "filter", "custompage"]}});

        try {
            const items = await fetchObjectList(dispatch, getState, query);
            const result = items.map(
                object => {
                    if (object.type === "filter") {
                        const query = parseBSON(object.fields.query, undefined, object.id);
                        const orderBy = parseBSON(object.fields.orderBy, {"title": 1}, object.id);
                        return {
                            ...object,
                            fields: {
                                ...object.fields,
                                query: query,
                                orderBy: orderBy
                            }
                        };
                    }
                    else {
                        return object;
                    }
                }
            );
            console.log("menus and filters", result);
            dispatch(loadMenuAction(result));
        }
        catch (error) {
            showError(error)(dispatch);
        }
    }
}

